


















































import Vue from "vue";
import Payments from "./Payments.vue";
import getCountryShippingData from "../util/endpoint";
import getFlag from "../util/getFlag";

export default Vue.extend({
  name: "List",
  components: {
    Payments,
  },
  props: {
    data: {
      type: Array,
      required: false,
    },
    country: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      shippingData: ([] as unknown) as [{}],
      loadedShippingData: [] as string[],
      paymentOptions: [],
      unknownCountry: false,
    };
  },
  computed: {
    // Not in use until images are ready
    // poster() {
    //   return require('@/assets/poster.png');
    // },
    // forex() {
    //   return require('@/assets/forex.png');
    // },
    // posterFramed() {
    //   return require('@/assets/posterFramed.png');
    // }
  },
  methods: {
    async getShippingData(country: string) {
      // Only load country's shipping data if not loaded once before, save loaded
      // shipping data country name in array to prevent fetching on every click.
      if (!this.loadedShippingData.includes(country)) {
        getCountryShippingData(country).then((data) => {
          const allShippingInformation = Object.keys(data.allShippingInformation);
          for (const printType of allShippingInformation) {
            this.shippingData.push({
              name: printType,
              ...data.allShippingInformation[printType],
            });
          }
          this.paymentOptions = data.paymentOptions;
        });
        this.loadedShippingData.push(country);
      }
    },
    getFlag(country: string) {
      return getFlag(country);
    },
    properName(type: string) {
      switch (type) {
        case "poster":
          return "Poster";
        case "forex":
          return "Metal Print";
        case "poster-framed":
          return "Framed Poster";
        default:
          return type.replace("-", " ");
      }
    },
  },
});
